"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var parts_1 = require("./parts");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var helper_1 = require("lib/functions/helper");
var moment_1 = __importDefault(require("moment"));
var Popup_1 = require("components/Popup");
var SignaturesCertificate_1 = require("../SignaturesCertificate");
var rules = {
    staff: {},
    student: {
        campus: validations_1.mandatory,
        first_name: validations_1.mandatory,
        last_name: validations_1.mandatory,
        address: __assign(__assign({}, validations_1.mandatory), { format: {
                pattern: /^((?!@).)*$/,
                flags: "gm",
                message: "can't be your email"
            } }),
        city: validations_1.mandatory,
        state: validations_1.mandatory,
        zip: __assign(__assign({}, validations_1.mandatory), { format: {
                pattern: /^\d{5}(?:[-\s]\d{4})?$/,
                flags: "gm",
                message: "^Invalid zip code format [XXXXX or XXXXX-XXXX]"
            } }),
        cell_phone: validations_1.mandatory,
        email: validations_1.email,
        state_agency_help_fund: validations_1.mandatory,
        attended_college: validations_1.mandatory,
        school_diploma: validations_1.mandatory,
        apply_federal_finaid: validations_1.mandatory,
        military_service_info: validations_1.mandatory,
        ready_commit_education: validations_1.mandatory,
        someone_benefit: validations_1.mandatory,
        student_signature: validations_1.mandatory
    }
};
var educationRules = {
    student: {
        school_year_graduate: validations_1.mandatory,
        high_school_country: validations_1.mandatory,
        high_school_name: validations_1.mandatory,
        high_school_city: validations_1.mandatory,
        high_school_state: validations_1.mandatory
    }
};
var militaryRules = {
    student: {
        military_branch: validations_1.mandatory
    }
};
var customCheckboxRules = {
    student: {
        pursue_education: {
            key: "pursue_education"
        },
        looking_for_in_college: {
            key: "looking_for_in_college"
        },
        school_most_asked_questions: {
            key: "school_most_asked_questions"
        }
    }
};
var getFormatDateNow = function () { return moment_1.default().format("MMMM Do YYYY"); };
var footer = {
    title: "",
    published: "Published: " + getFormatDateNow(),
    endPage: "1"
};
var Application = (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChangeCampuses = function (e, id) {
            var checked = e.target.checked;
            var campuses = _this.json_data.campuses;
            campuses.map(function (campus) {
                if (campus.id === id) {
                    campus.checked = checked;
                }
                else {
                    campus.checked = false;
                }
            });
            var campusesSelected = campuses.filter(function (_a) {
                var checked = _a.checked;
                return checked === true;
            });
            if (campusesSelected.length > 0) {
                var aCampus = campusesSelected[0];
                _this.json_data.campus = "" + aCampus.id + helper_1.DELIMITER + aCampus.name + helper_1.DELIMITER + aCampus.abbreviation + helper_1.DELIMITER + aCampus.checked;
            }
            else {
                delete _this.json_data.campus;
            }
            _this.forceUpdate();
        };
        _this.clearInputsAuthorizedIndividuals = function () {
            delete _this.json_data.employed_1_name;
            delete _this.json_data.employed_1_address;
            delete _this.json_data.employed_1_city;
            delete _this.json_data.employed_1_state;
            delete _this.json_data.employed_1_zip;
            delete _this.json_data.employed_1_phone;
            delete _this.json_data.employed_1_supervisor;
            delete _this.json_data.employed_1_position;
            delete _this.json_data.employed_1_start_date;
        };
        _this.onClickLogin = function () {
            _this.setState({ isVisible: true });
        };
        _this.onClickLogout = function () {
            _this.setState({ isVisible: false });
        };
        _this.onClose = function () {
            _this.setState({ isVisible: false });
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        _this.state = {
            isVisible: false
        };
        return _this;
    }
    Object.defineProperty(Application.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    Application.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Application.prototype.onChange = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("Id", id);
                        console.log("Value", value);
                        this.json_data[id] = value;
                        if (!(id === "campus")) return [3, 2];
                        delete this.json_data.program;
                        return [4, this.props.model.getPrograms(value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (id === "country") {
                            delete this.json_data.state;
                        }
                        if (id === "high_school_country")
                            [delete this.json_data.high_school_state];
                        if (id === "school_diploma") {
                            if (this.json_data.school_diploma === "yes") {
                                this.json_data.school_type = "high-school";
                            }
                            else {
                                delete this.json_data.school_type;
                            }
                        }
                        if (id === "military_status") {
                            this.json_data.military_service_info = "yes";
                        }
                        this.forceUpdate();
                        return [2];
                }
            });
        });
    };
    Application.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.props.model.dispatcher.dispatch();
                        this.props.model.addValidateFunction("validateApplication", this.isValid);
                        if (!!window.isPdf) return [3, 4];
                        return [4, this.props.model.getApiKeyBySlug()];
                    case 1:
                        _a.sent();
                        return [4, this.props.model.getCampuses()];
                    case 2:
                        _a.sent();
                        return [4, this.props.model.getHowDidYouKnowAboutUsList()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    Application.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (prevProps.model.user) {
                    this.props.model.addValidateFunction("validateApplication", this.isValid);
                }
                return [2];
            });
        });
    };
    Application.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Application.prototype.isValid = function () {
        console.log("Validate Application");
        var newRules = rules.student;
        var newEducationRules = educationRules.student;
        var newMilitaryRules = militaryRules.student;
        if (this.json_data.school_diploma === "yes") {
            newRules = __assign(__assign({}, newRules), newEducationRules);
        }
        if (this.json_data.military_status !== "not_veteran") {
            newRules = __assign(__assign({}, newRules), newMilitaryRules);
        }
        var _a = findErrors_1.findErrors(this.json_data, newRules), isValid = _a.isValid, errors = _a.errors;
        var _b = findErrors_1.findErrorsInChecbox(this.json_data.looking_for_in_college, customCheckboxRules.student.looking_for_in_college.key), isValidLookingInCollege = _b.isValid, errorsLookingInCollege = _b.errors;
        var _c = findErrors_1.findErrorsInChecbox(this.json_data.pursue_education, customCheckboxRules.student.pursue_education.key), isValidPursueEducation = _c.isValid, errorsPursueEducation = _c.errors;
        var _d = findErrors_1.findErrorsInChecbox(this.json_data.school_most_asked_questions, customCheckboxRules.student.school_most_asked_questions.key), isValidMostAskedQuestions = _d.isValid, errorsMostAskedQuestions = _d.errors;
        this.errors = __assign(__assign(__assign(__assign({}, errors), errorsLookingInCollege), errorsPursueEducation), errorsMostAskedQuestions);
        console.log("Form errors", this.errors);
        return (isValid &&
            isValidLookingInCollege &&
            isValidPursueEducation &&
            isValidMostAskedQuestions);
    };
    Application.prototype.render = function () {
        var model = this.props.model;
        var _a = this, errors = _a.errors, onChange = _a.onChange, onClickLogin = _a.onClickLogin, onClickLogout = _a.onClickLogout, onClose = _a.onClose, onChangeCampuses = _a.onChangeCampuses;
        var isVisible = this.state.isVisible;
        return (React.createElement("div", null,
            isVisible && React.createElement(Popup_1.Popup, { model: this.props.model, onClose: onClose }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(parts_1.Section1, { model: model, onChange: onChange, errors: errors, onClickLogin: onClickLogin, onClickCampuses: onChangeCampuses }),
            React.createElement("div", { className: "gray-divider" }),
            React.createElement("footer", { className: "gray-divider" }),
            window.isPdf && (React.createElement(SignaturesCertificate_1.SignatureCertificate, { model: model, title: "Signature certificate", subtitle: "Document Disclosure", signatureId: "signature" }))));
    };
    __decorate([
        mobx_1.observable
    ], Application.prototype, "errors", void 0);
    Application = __decorate([
        mobx_react_1.observer
    ], Application);
    return Application;
}(react_1.Component));
exports.Application = Application;
//# sourceMappingURL=data:application/json;base64,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